<!-- eslint-disable vue/html-indent -->
<template>
    <div
        class="planCard mobile:p-4 tablet:p-4 mobile:mx-1 mobile:my-2 tablet:my-3 tablet:mx-4 flex flex-col justify-start items-start gap-2 rounded-xl shadow-[0px_0px_10px_0px_#00000026;] bg-white"
>
        <div class="flex items-center !justify-between py-2 !w-full">
            <div class="flex justify-start items-center gap-1">
                <div class="w-1.5 h-1.5 rounded-full bg-purple-100" />
                <div class="w-6 h-1.5 rounded-full bg-purple-100" />
                <p class="text-lg font-semibold font-roboto pl-2 m-0 text-fuchsia-700">
New Plan
</p>
            </div>
            <div>
                <slot name="action" />
            </div>
        </div>
        <h4
            class="mobile:text-lg tablet:text-xl largeDesktop:text-2xl font-roboto font-semibold m-0 !w-full items-start text-left min-h-24 text-[#333333]"
>
            {{ plan.plan_name.length
                > 80 ? plan.plan_name.slice(0, 10) + '...' : plan.plan_name }}
</h4>
        <span class="m-0 mobile:text-base largeDesktop:text-lg font-roboto font-medium text-red-400 !leading-[0.5]">{{ plan.months + ' months plan' }}</span>
        <h2 class="mobile:text-3xl tablet:text-3xl largeDesktop:text-4xl font-roboto font-bold m-0 text-[#333333]">
${{
            $helper.formatAmount(plan.amount) }}<span class="text-xl">/mo</span>
</h2>
        <div class="py-1">
            <div class="w-full h-40 m-0 overflow-y-auto customScrollbar planDescription" v-html="plan.description" />
        </div>
        <span
v-if="plan.quantity == 0" class="group px-3 py-1.5 flex justify-center items-center mx-auto gap-1 text-base rounded-full cursor-pointer border-[1px] !border-secondary-100 text-secondary-100 hover:bg-secondary-100 hover:text-white"
            @click="updateCounter('increment')"
>
            <img src="../../assets/images/cart-check.png" class="w-7 h-7 object-contain group-hover:hidden" alt="icon">
            <img
src="../../assets/images/cart-check-white.png"
                class="w-7 h-7 object-contain !hidden group-hover:!block" alt="icon"
>
            Select this plan
        </span>

        <div v-else class="flex w-full justify-center items-center gap-4">
            <quantityCounter
v-if="plan.is_show_quantity == 1" :quantity="plan.quantity"
                @update-counter="updateCounter"
/>
            <button
v-else type="button" class="group !h-10 !w-10 flex items-center justify-center rounded-full focus:outline-0 transition-all border-1 border-[#F67280] !bg-transparent hover:!bg-[#F67280]"
                @click="updateCounter('remove')"
>
                <img
src="../../assets/images/trash-icon-updated.png" alt="Cart Icon"
                    class="!w-7 !h-7 group-hover:hidden"
>
                <img
src="../../assets/images/trash-icon-white-updated.png" alt="Cart Icon"
                    class="!w-7 !h-7 hidden group-hover:!block"
>
            </button>
            <img src="../../assets/images/cart-icon-with-bg.svg" alt="Cart Icon" class="!w-10 !h-10">
        </div>
    </div>
</template>

<script>
import quantityCounter from '../partialComponent/quantityCounter.vue';

export default {

    components: {
        quantityCounter,
    },
    props: {
        plan: Object,
        isSelected: Boolean,
        updateCart: Function,
        updateCard: Object,
    },
    data() {
        return {
            localObject: null
        }
    },

    watch: {
        updateCard: function (data) {
            if (data && this.localObject){
                this.plan.quantity = this.localObject.quantity
            }
            // this.localObject = null
        },
    },

    methods: {
        updateCounter(option) {
            this.localObject = JSON.parse(JSON.stringify(this.plan))
            if (option == "increment") {
                this.localObject.quantity++
            } else if (option == "decrement") {
                if (this.localObject.quantity > 1) {
                    this.localObject.quantity--
                } else {
                    this.localObject.quantity = 0
                }
            } else {
                this.localObject.quantity = 0
            }

            this.updateCart(option, {
                id: this.localObject.id,
                quantity: this.localObject.quantity
            })
        },
    }

}
</script>

<style>
.carousel__slide--active .planCard {
    border: 1px solid #c084fc;
}

.planDescription ul {
    padding: 0;
    text-align: left;
    font-family: 'Lato' !important;
}

.planDescription ul li {
    padding-left: 2rem;
    position: relative;
    font-size: 16px !important;
    font-weight: 400 !important;
    font-family: 'Lato' !important;
    color: #333333 !important;
}

.planDescription ul li:after {
    position: absolute;
    content: "";
    top: 2px;
    left: 0;
    background-image: url('../../assets/images/double-check-pruple.png');
    background-position: center;
    background-size: contain;
    width: 22px;
    height: 22px;
}

.planDescription p a,
.planDescription a {
    color: #A084E8;
}

.planDescription ul li span,
.planDescription p span {
    font-size: 16px !important;
}
</style>